import {
    FURUI_CHOOSE_CURRENT_FRUI_BASEDATA,
} from './constants';
  
export function chooseCurrentFrui_basedata(modal) {
    return {
      type: FURUI_CHOOSE_CURRENT_FRUI_BASEDATA,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case FURUI_CHOOSE_CURRENT_FRUI_BASEDATA:
        return {
          ...state,
          currentFrui_basedata:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/furui/redux/chooseCurrentFrui_basedata.js